import React, { useMemo } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useDocumentMeta, useStructuredData } from '../hooks/useDocumentMeta';
import { AGENT_DISPLAY_NAME, BROKERAGE_NAME, BUSINESS_EMAIL, BUSINESS_PHONE_DISPLAY, OFFICIAL_LISTING_URL, OFFICIAL_PROFILE_URL, PROPERTY_PRICE_NUMERIC, SITE_URL } from '../data/contact';
import { getImage } from '../data/images';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { StatsSection } from '../components/StatsSection';
import { DescriptionSection } from '../components/DescriptionSection';
import { GallerySection } from '../components/GallerySection';
import { InteriorSection } from '../components/InteriorSection';
import { BedroomsSection } from '../components/BedroomsSection';
import { WaterViewSection } from '../components/WaterViewSection';
import { AmenitiesSection } from '../components/AmenitiesSection';
import { LocationSection } from '../components/LocationSection';
import { OwnershipSection } from '../components/OwnershipSection';
import { AgentSection } from '../components/AgentSection';
import { ListingLinksSection } from '../components/ListingLinksSection';
import { ContactSection } from '../components/ContactSection';
import { BuyersAgentSection } from '../components/BuyersAgentSection';
import { Footer } from '../components/Footer';
import { StickyMobileBar } from '../components/StickyMobileBar';
export function Home() {
  const {
    t
  } = useLanguage();
  const heroImage = getImage('exterior');
  useDocumentMeta({
    title: t('1039 Plantation Ln | Furnished Davenport Townhome Near Disney', '1039 Plantation Ln | Townhome Amoblada en Davenport Cerca de Disney'),
    description: t('Explore this fully furnished 3-bedroom, 2.5-bath water-view townhome in Davenport, Florida, with 1,622 sq ft and resort-style amenities near Disney.', 'Conoce esta townhome completamente amoblada de 3 habitaciones y 2.5 baños con vista al agua en Davenport, Florida, con 1,622 pies² y amenidades estilo resort cerca de Disney.'),
    socialTitle: 'Fully Furnished Water-View Townhome Near Disney',
    socialDescription: 'Three bedrooms, 2.5 bathrooms, 1,622 sq ft and resort-style amenities in Davenport, Florida.',
    socialImage: heroImage?.src,
    canonical: SITE_URL
  });

  /** Approved public information only — no license number or personal address. */
  const structuredData = useMemo(() => ({
    '@context': 'https://schema.org',
    '@graph': [{
      '@type': 'RealEstateListing',
      name: '1039 Plantation Ln — Furnished Water-View Townhome',
      url: SITE_URL,
      image: heroImage?.src,
      datePosted: '2026-08-01',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '1039 Plantation Ln',
        addressLocality: 'Davenport',
        addressRegion: 'FL',
        postalCode: '33896',
        addressCountry: 'US'
      },
      offers: {
        '@type': 'Offer',
        price: PROPERTY_PRICE_NUMERIC,
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock',
        url: OFFICIAL_LISTING_URL
      },
      numberOfBedrooms: 3,
      numberOfBathroomsTotal: 2.5,
      yearBuilt: 2023,
      floorSize: {
        '@type': 'QuantitativeValue',
        value: 1622,
        unitCode: 'FTK'
      }
    }, {
      '@type': 'RealEstateAgent',
      name: AGENT_DISPLAY_NAME,
      jobTitle: 'Real Estate Professional',
      telephone: BUSINESS_PHONE_DISPLAY,
      email: BUSINESS_EMAIL,
      url: OFFICIAL_PROFILE_URL,
      worksFor: {
        '@type': 'RealEstateAgent',
        name: BROKERAGE_NAME
      },
      areaServed: 'Davenport, Florida'
    }]
  }), [heroImage?.src]);
  useStructuredData('property-structured-data', structuredData);
  return <div className="w-full bg-white" data-id="element-465" data-mp="1c5t03olfwca7">
      <a href="#property" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[80] focus:bg-gold focus:px-4 focus:py-2 focus:text-[12px] focus:uppercase focus:tracking-[0.14em] focus:text-midnight" data-id="element-466" data-mp="27eeq0aobh1hx">
        {t('Skip to property details', 'Ir a los detalles de la propiedad')}
      </a>

      <Header data-id="element-467" data-mp="2mcqkqbs4q06g" />

      <main data-id="element-468" data-mp="2m92qfaev19qo">
        <HeroSection data-id="element-469" data-mp="2m8t35ul79goo" />
        <StatsSection data-id="element-470" data-mp="2qdai9ggm75t4" />
        <DescriptionSection data-id="element-471" data-mp="2qbpqtzplk2zh" />
        <GallerySection data-id="element-472" data-mp="2qchbifhnogaz" />
        <InteriorSection data-id="element-473" data-mp="2vbu4lhz4ejm0" />
        <BedroomsSection data-id="element-474" data-mp="2vb2aycp32vyd" />
        <WaterViewSection data-id="element-475" data-mp="2va9b7vojl6pq" />
        <AmenitiesSection data-id="element-476" data-mp="2v9heuin4f4ye" />
        <LocationSection data-id="element-477" data-mp="302tz6gkroplc" />
        <OwnershipSection data-id="element-478" data-mp="303lo58juzp2n" />
        <AgentSection data-id="element-479" data-mp="303c5k6158k6z" />
        <ListingLinksSection data-id="element-480" data-mp="351nhcmb014ru" />
        <ContactSection data-id="element-481" data-mp="351wwfeui9rir" />
        <BuyersAgentSection data-id="element-482" data-mp="3513yn3diyccr" />
      </main>

      <Footer data-id="element-483" data-mp="3a0qdfh9040no" />
      <StickyMobileBar data-id="element-484" data-mp="3a19vcxynip1p" />
    </div>;
}